import { IPaymentsAndDeductions } from 'API/paymentAndDeductions';
import { IAdvancedSearchState } from './AdvancedSearchReducer';
import { BENEFITS_GROUP_STATUS } from 'Enum/paymentsDeduction';
import { isAfter, isBefore, isWithinInterval } from 'date-fns';
import { replaceZerosWithHyphen } from 'Utils/replaceZerosWithHyphen';

export interface IPaymentsDeductionsState {
  paymentsDeductions: IPaymentsAndDeductions[];
  filteredPaymentsDeductions: IPaymentsAndDeductions[];
}

export function PaymentsDeductionsReducer(
  state: IPaymentsDeductionsState,
  action: any
) {
  switch (action.type) {
    case 'INITIALIZATION': {
      const sortedPaymentsDeductions: IPaymentsAndDeductions[] =
        action.payload.value.sort(
          (a: IPaymentsAndDeductions, b: IPaymentsAndDeductions) =>
            new Date(b.statusDate).getTime() - new Date(a.statusDate).getTime()
        );
      const updatedPaymentsDeductions = sortedPaymentsDeductions.map(
        (payment) => ({
          ...payment,
          requestNumber: replaceZerosWithHyphen(payment.requestNumber),
        })
      );
      const paymentsDeductions = updatedPaymentsDeductions;
      const filteredPaymentsDeductions = updatedPaymentsDeductions;
      return { ...state, paymentsDeductions, filteredPaymentsDeductions };
    }
    case 'SEARCH_PAYMENT_DEDUCTION': {
      const filteredPaymentsDeductions = SearchPaymentDeductionBySubject(
        state.paymentsDeductions,
        action.payload.value
      );
      return { ...state, filteredPaymentsDeductions };
    }
    case 'ADVANCED_SEARCH': {
      const filteredPaymentsDeductions = AdvancedSearch(
        state.paymentsDeductions,
        action.payload.value
      );
      return { ...state, filteredPaymentsDeductions };
    }
    case 'RESET': {
      const filteredPaymentsDeductions = state.paymentsDeductions;
      return { ...state, filteredPaymentsDeductions };
    }
    default:
      return state;
  }
}
/**
 * Filters paymentDeduction array according to a search value according to 'part' field.
 * @param paymentDeductions All payment deduction list.
 * @param searchValue string search input value
 * @returns Filtered paymentDeduction list.
 */
function SearchPaymentDeductionBySubject(
  paymentDeductions: IPaymentsAndDeductions[],
  searchValue: string
) {
  const filteredPaymentsDeductions: IPaymentsAndDeductions[] = [];
  filteredPaymentsDeductions.push(
    ...paymentDeductions.filter((paymentDeduction: IPaymentsAndDeductions) =>
      paymentDeduction.part.includes(searchValue)
    )
  );
  return filteredPaymentsDeductions;
}

/**
 * Filters paymentDeduction array according to the advanced search object fields.
 * @param paymentDeductions All payment deduction list.
 * @param searchFields Advanced Search Object
 * @returns Filtered paymentDeduction list.
 */
function AdvancedSearch(
  paymentDeductions: IPaymentsAndDeductions[],
  searchFields: IAdvancedSearchState
) {
  const filteredPaymentsDeductions = paymentDeductions.filter(
    (paymentDeduction: IPaymentsAndDeductions) => {
      const { requestState, requestNumber, requestType, dateRange } =
        searchFields;
      if (requestState !== null && requestState !== paymentDeduction.statusCode)
        return false;
      if (
        requestNumber !== null &&
        !paymentDeduction.requestNumber
          .toString()
          .includes(requestNumber.toString())
      )
        return false;

      if (requestType.refund || requestType.payment || requestType.deduction) {
        if (
          requestType.refund &&
          paymentDeduction.benefitGroupCode === BENEFITS_GROUP_STATUS.PROACTIVE
        )
          return true;
        if (
          requestType.payment &&
          paymentDeduction.benefitGroupCode === BENEFITS_GROUP_STATUS.AUTOMATIC
        )
          return true;
        if (
          requestType.deduction &&
          paymentDeduction.benefitGroupCode === BENEFITS_GROUP_STATUS.DEDUCTION
        )
          return true;
        return false;
      }

      // Date handler , checks all possible 3 ways , between 2 dates , after start , before end.
      if (dateRange.start || dateRange.end) {
        const openDate = new Date(paymentDeduction.statusDate);
        if (dateRange.start && dateRange.end) {
          if (isAfter(dateRange.start, dateRange.end)) return false;
          return isWithinInterval(openDate, {
            start: new Date(dateRange.start),
            end: new Date(dateRange.end),
          });
        } else if (dateRange.start && !dateRange.end)
          return isAfter(openDate, new Date(dateRange.start));
        else if (dateRange.end)
          return isBefore(openDate, new Date(dateRange.end));
      }

      return true;
    }
  );
  return filteredPaymentsDeductions;
}
